<template>
  <v-card>
    <v-card-title primary-title class="greyk lighten-4k">
      <h4 class="headline mb-0">{{ $t('guardians') }}</h4>
      <v-btn icon color="primary" @click="showD=!showD" class="elevation-5">
        <v-icon>add</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="search"
        label="Search"
        single-line
        hide-details
        style="max-width:40%"
      ></v-text-field>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text>
      <v-data-table
        :headers="guardian_headers"
        :items="guardians"
        class="elevation-0"
        :search="search"
      >
        <template v-slot:items="props">
          <td>{{ props.index + 1 }}</td>
          <td>
            <v-img
              :src="'/images/avatars/'+props.item.avatar"
              lazy-src="../../../../img/user.jpg"
              alt="profile pic"
              class="mt-2"
              style="width:50px;height:50px;border-radius:50%"
              v-if="props.item.avatar"
            />
            <img
              src="../../../../img/user.jpg"
              alt="profile pic"
              class="mt-2"
              style="width:50px;height:50px;border-radius:50%"
              v-else
            />
          </td>
          <td class="text-xs-center">{{ props.item.name }}</td>
          <td class="text-xs-center">{{ props.item.email?props.item.email:'N/A' }}</td>
          <td class="text-xs-center">{{ props.item.phone }}</td>
          <td
            class="text-xs-center"
          >{{ props.item.g_wards_count? props.item.g_wards_count : 'N/A' }}</td>
          <td
            class="text-xs-center"
          >{{ props.item.status && props.item.status ==1?"Active" : "Inactive" }}</td>

          <td class="text-xs-center">
            <v-layout row wrap>
              <v-flex xs6>
                <v-btn flat icon color="blue" @click="editguardian(props.item)">
                  <v-icon>edit</v-icon>
                </v-btn>
              </v-flex>

              <v-flex xs6>
                <v-btn flat icon color="pink" @click="deleteguardian(props.item,props.index)">
                  <v-icon>delete</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </td>
        </template>
      </v-data-table>
    </v-card-text>

    <!-- add-edit guardian dialog -->
    <m-dialog pers title="Guardian" :show="showD">
      <template v-slot:header-actions>
        <v-btn @click="showD=!showD" icon style="cursor:pointer">
          <v-icon>close</v-icon>
        </v-btn>
      </template>

      <template v-slot:content>
        <v-form ref="form">
          <div style="text-align:center">
            <profile-img
              field="img"
              @crop-success="cropSuccess"
              v-model="showCrop"
              :width="300"
              :height="300"
              img-format="png"
              langType="en"
              :noCircle="true"
            ></profile-img>

            <v-img
              v-if="imgDataUrl"
              :src="imgDataUrl"
              width="150px"
              height="150px"
              style="display:block;margin:0 auto;border-radius:10px"
            />
            <v-btn
              @click="showCrop=!showCrop"
              color="primary"
              style="margin-top:10px;border-radius:20px"
            >select image</v-btn>
          </div>
          <v-switch
            :true-value="1"
            :false-value="0"
            v-model="guardian_model.status"
            label="Account Status"
            v-if="editedIndex>-1"
          ></v-switch>
          <v-text-field label="Name" v-model="guardian_model.name" :rules="validRules.required" />
          <v-text-field label="Email" v-model="guardian_model.email" :rules="validRules.email" />
          <v-text-field label="Phone" v-model="guardian_model.phone" :rules="validRules.required" />
          <v-text-field
            type="password"
            label="Password"
            v-model="guardian_model.password"
            :rules="editedIndex>-1?[]:validRules.password"
            :counter="true"
          />
          <!-- <v-text-field label="Photo" v-model="guardian_model.avatar" /> -->
        </v-form>
      </template>

      <template v-slot:footer-actions>
        <v-btn
          style="cursor:pointer"
          color="success"
          @click="saveguardian()"
          :loading="loading"
        >save</v-btn>
        <v-btn @click="showD=!showD" style="cursor:pointer" color="error">close</v-btn>
      </template>
    </m-dialog>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
import Modal from "../../../components/Modal";
// import VueCropAvatar from 'vue-crop-avatar'
import profileImg from "vue-image-crop-upload";

export default {
  name: "guardians-view",
  layout: "admin",
  metaInfo() {
    return { title: this.$t("guardians") };
  },
  components: {
    "m-dialog": Modal,
    profileImg
    //VueCropAvatar
  },
  data() {
    return {
      showD: false,
      showCrop: false,
      imgDataUrl: "",
      search: "",
      editedIndex: -1,
      guardian_model: {
        name: "",
        phone: "",
        email: "",
        password: "",
        avatar: "",
        avatar_data: "",
        status: 1
      },
      guardian_modelcp: {
        name: "",
        phone: "",
        email: "",
        password: "",
        avatar: "",
        avatar_data: "",
        status: 1
      },
      guardian_headers: [
        {
          text: "SN",
          align: "center",
          sortable: false,
          value: "level"
        },
        {
          text: "Image",
          align: "center",
          sortable: false,
          value: "class"
        },
        {
          text: "Name",
          align: "center",
          sortable: true,
          value: "name"
        },
        ,
        {
          text: "Email",
          align: "center",
          sortable: true,
          value: "email"
        },
        {
          text: "Phone",
          align: "center",
          sortable: true,
          value: "phone"
        },
        ,
        {
          text: "Ward Count",
          align: "center",
          sortable: false,
          value: "ward_count"
        },
        {
          text: "Acct. Status",
          align: "center",
          sortable: false,
          value: "status"
        },
        {
          text: "Actions",
          align: "center",
          sortable: false,
          value: "name"
        }
      ]
    };
  },
  mounted() {
    this.$store.dispatch("guardians/getAll");

    //console.log("guardiansooooo",guardians)
  },
  computed: {
    ...mapGetters({
      guardians: "guardians/GUARDIANS",
      gerrors: "guardians/GUARDIAN_ERROR",
      loading: "guardians/GUARDIAN_LOADING"
    }),
    imgL: imglink => {
      return "/images/avatars/" + umglink;
    }
  },
  methods: {
    cropSuccess(imgDataUrl, field) {
      this.imgDataUrl = imgDataUrl;
      this.guardian_model.avatar_data = imgDataUrl;
    },

    addguardian() {
      this.$store.dispatch("guardians/add", this.guardian_model);

      if (this.gerrors == null) {
        this.guardian_model = {
          name: "",
          phone: "",
          email: "",
          password: "",
          avatar: "",
          avatar_data: "",
          status: 1
        };
        this.$store.dispatch("responseMessage", {
          type: "success",
          text: "Guardian added successfully.",
          title: "Guardian",
          modal: false
        });
      } else {
        this.$store.dispatch("responseMessage", {
          type: "warning",
          text: "Sorry, an error occured and guardian could not be added.",
          title: "Guardian",
          modal: false
        });
      }
    },
    deleteguardian(guardian, index) {
      if (confirm("Are you sure you want to delete this guardian?")) {
        let idx = this.guardians.indexOf(guardian);
        this.$store.dispatch("guardians/delete", { guardian, index: idx });
        this.$store.dispatch("responseMessage", {
          type: "success",
          text: "Guardian deleted successfully.",
          title: "Guardian",
          modal: false
        });
      }
    },

    editguardian(guardian) {
      this.editedIndex = this.guardians.indexOf(guardian);
      this.guardian_model = Object.assign({}, guardian);

      this.imgDataUrl = this.guardian_model.avatar
        ? "/images/avatars/" + this.guardian_model.avatar
        : "../../../../img/user.jpg";

      //alert(this.editedIndex)

      this.showD = true;
    },
    updateguardian(guardian, index) {
      this.$store.dispatch("guardians/update", { index, guardian });

      if (this.gerrors == null) {
        this.guardian_model = {
          name: "",
          phone: "",
          email: "",
          password: "",
          avatar: "",
          avatar_data: "",
          status: 1
        };
        this.editedIndex = -1;
        this.showD = false;
        this.$store.dispatch("responseMessage", {
          type: "success",
          text: "Guardian updated successfully.",
          title: "Guardian",
          modal: false
        });
      }
    },

    saveguardian() {
      if (!this.$refs.form.validate()) {
        return;
      }
      //decides between editing guardian info or saving guardian info
      if (this.editedIndex > -1) {
        this.updateguardian(this.guardian_model, this.editedIndex);
      } else {
        this.addguardian();
      }
    }
  },
  watch: {
    showD(val) {
      if (val == false) {
        this.guardian_model = {
          status: 1
        };
        this.imgDataUrl = "";
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/admin/guardians/guardians.vue